export default __webpack_public_path__ + "static/media/torch.0fe38fcd.svg";